import { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ServicesDetails from "./ServicesDetails";
import UseToggle from "../../../Hooks/UseToggle";

const ServicesSection = ({servicesSection, menuId, themeColor, sendNotification}) => {
  const [selectedService, setSelectedService] = useState("");
  const toggles = UseToggle();
  return (
    <div style={{background: `linear-gradient(360deg, ${themeColor} -700%, #eef2ff30)`,}}>
      <Container id={menuId} className="py-5">
        <h2 className="fw-bold text-center">{servicesSection?.servicesSectionTitle}</h2>
        <p
          className="text-center text-muted fs-5 mt-3 mb-5"
          style={{ maxWidth: 820, margin: "0 auto" }}
        >
          {servicesSection?.servicesSectionSubTitle}
        </p>
        <Row className="g-4">
          {(servicesSection?.services || []).map((service) => (
            <Col md={4} key={service.id}>
              <Card className="border-0 shadow-sm rounded-4 h-100">
                <Card.Img
                  variant="top"
                  style={{ height: 200, objectFit: "cover" }}
                  src={"https://i.pravatar.cc/?img=1"}
                />
                <Card.Body>
                  <h5 className="fw-bold">{service.title}</h5>
                  <p className="text-muted">{service.shortDescription}</p>

                  <Button
                    className="fw-semibold px-3"
                    style={{fontSize: 12, backgroundColor: themeColor, borderColor: themeColor}}
                    size="sm"
                    onClick={() => {
                      setSelectedService(service); 
                      toggles.setToggle();
                      sendNotification("notification", `Visitor Navigated to the ${service.title} Service Details.`)
                    }}
                  >
                    View Details →
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <ServicesDetails
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        selectedService={selectedService}
      />
    </div>
  );
};

export default ServicesSection;
